import { Link } from "react-router-dom";
import { events } from "@/mocks/site";
import { formatDate } from "@/utils/format";

const editorNotes = [
  {
    title: "关于「时间线优先」的取舍",
    text: "我们更愿意先给你一条可以核对的时间顺序，而不是一句情绪化的结论。结论会过时，时间线不会。",
  },
  {
    title: "为什么有些事我们写得慢",
    text: "如果关键节点只有单一来源，我们会等第二个可核实的公开信息出现。慢一点，但每一句都有出处。",
  },
  {
    title: "文中如何标注不确定性",
    text: "凡是暂时无法从公开信息确认的部分，我们都会在正文里单独说明，而不是含糊带过。",
  },
];

const sideLinks = [
  { to: "/archive?category=screen", label: "影视剧集类档案" },
  { to: "/archive?category=live", label: "演出票务类档案" },
  { to: "/archive?category=brand", label: "商业代言类档案" },
  { to: "/about", label: "了解我们的内容原则" },
];

export default function LatestList() {
  const list = events.slice(4, 9);

  return (
    <section className="container-x py-14 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <div className="flex items-end justify-between gap-4">
            <div>
              <p className="text-xs font-medium tracking-[0.2em] text-primary-600">LATEST / 最新更新</p>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                刚刚补进来的时间线
              </h2>
            </div>
            <Link
              to="/archive"
              className="hidden whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 sm:inline-flex sm:items-center sm:gap-1"
            >
              全部档案
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <ul className="mt-8 divide-y divide-background-200 border-t border-background-200">
            {list.map((event) => (
              <li key={event.slug} className="group py-6">
                <Link to={`/archive/${event.slug}`} className="flex flex-col gap-4 sm:flex-row sm:gap-6">
                  <div className="flex shrink-0 items-baseline gap-3 sm:w-32 sm:flex-col sm:items-start sm:gap-1">
                    <span className="font-heading text-lg font-bold text-primary-600">
                      {event.date.split("-")[2]}
                    </span>
                    <span className="text-xs text-foreground-500">{formatDate(event.date)}</span>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading text-base font-bold leading-7 text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                      {event.title}
                    </h3>
                    <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{event.excerpt}</p>
                    <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                      <span className="rounded-full bg-background-100 px-2.5 py-1">{event.category}</span>
                      <span>{event.author}</span>
                      <span>{event.readTime}</span>
                    </div>
                  </div>
                  <span className="hidden shrink-0 items-center self-center text-foreground-300 transition-colors group-hover:text-primary-500 sm:flex">
                    <i className="ri-arrow-right-up-line text-xl"></i>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <aside className="lg:col-span-4">
          <div className="rounded-lg border border-background-200 bg-background-100 p-6">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-quill-pen-line text-primary-600"></i>
              编辑手记
            </h3>
            <ul className="mt-5 space-y-5">
              {editorNotes.map((note) => (
                <li key={note.title} className="border-l-2 border-accent-400 pl-4">
                  <p className="font-heading text-sm font-bold text-foreground-950">{note.title}</p>
                  <p className="mt-1.5 text-sm leading-6 text-foreground-600">{note.text}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-6">
            <h3 className="font-heading text-base font-bold text-foreground-950">快速入口</h3>
            <ul className="mt-4 space-y-3">
              {sideLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="flex items-center justify-between gap-3 text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                    <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}